module.exports = __webpack_public_path__ + "static/media/paper-prototyping.e46c5dca.jpeg";